import { renderSlot as _renderSlot, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Teleport as _Teleport, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-14"
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("span", _mergeProps({
      class: ["tooltip__title", _ctx.classCustom],
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTooltip('click'))),
      onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTooltip('hover'))),
      onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args))),
      ref: "tooltipParent"
    }, _ctx.$attrs, {
      style: [
            {
                borderRadius: _ctx.borderRadius,
            },
        ]
    }), [
      _renderSlot(_ctx.$slots, "default")
    ], 16),
    (_openBlock(), _createBlock(_Teleport, { to: "#tooltip" }, [
      (_ctx.isShowTooltip && !_ctx.disabled)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            ref: "tooltipChild",
            onMouseenter: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onHoverTooltipContent && _ctx.onHoverTooltipContent(...args))),
            onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args))),
            class: ["tooltip__content break-words w-full fixed text-14 z-999 block text-left", [
                _ctx.positionTooltip,
                _ctx.maxWidthContent ? _ctx.maxWidthContent : 'max-w-320',
                _ctx.minWidthContent ? _ctx.minWidthContent : '',
            ]],
            style: [
                {
                    width: _ctx.width != '' ? _ctx.width + 'px' : 'max-content',
                    right: _ctx.rightTooltip !== 'auto' ? `${_ctx.rightTooltip}px` : _ctx.rightTooltip,
                    left: _ctx.leftTooltip !== 'auto' ? `${_ctx.leftTooltip}px` : _ctx.leftTooltip,
                    top: _ctx.topTooltip !== 'auto' ? `${_ctx.topTooltip}px` : _ctx.topTooltip,
                    bottom: _ctx.bottomTooltip !== 'auto' ? `${_ctx.bottomTooltip}px` : _ctx.bottomTooltip,
                },
            ]
          }, [
            _createVNode("span", {
              class: [[_ctx.sizeTooltip, _ctx.typeTooltip], "tooltip__inner rounded relative block"]
            }, [
              (_ctx.$slots.content)
                ? (_openBlock(), _createBlock("span", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "content")
                  ]))
                : (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.showTime ? _ctx.filters.formatTime(_ctx.content, false, true) : _ctx.content), 1)),
              _createVNode("span", {
                ref: "tooltipArrow",
                class: "tooltip__arrow fixed border-solid border-4",
                style: {
                        borderColor: _ctx.borderColorArrow,
                        right: _ctx.rightArrow !== 'auto' ? `${_ctx.rightArrow}px` : _ctx.rightArrow,
                        left: _ctx.leftArrow !== 'auto' ? `${_ctx.leftArrow}px` : _ctx.leftArrow,
                        top: _ctx.topArrow !== 'auto' ? `${_ctx.topArrow}px` : _ctx.topArrow,
                        bottom: _ctx.bottomArrow !== 'auto' ? `${_ctx.bottomArrow}px` : _ctx.bottomArrow,
                    }
              }, null, 4)
            ], 2)
          ], 38))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}